export const woltDeliveryApp = {
  id: 93,
  name: "woltdelivery",
  useOAuth: true,
  // Renews its OAuth token through the core reauthorization endpoint
  // (apps/initializeReauthorization) instead of a direct provider redirect
  showReauthorizeButton: true,
  label: "Wolt Delivery",
  logo: process.env.BASE_URL + "media/shopLogos/wolt-delivery.png",
  areaBlacklist: ["migration", "reporting"],
  additional_params: undefined,
  environmentVariables: {
    oauth: {
      client_id: process?.env?.VUE_APP_WOLT_CLIENT_ID,
      redirect_url: process?.env?.VUE_APP_WOLT_REDIRECT_URL
    },
    presetId: process.env.VUE_APP_SCM_APP_WOLT_DELIVERY_PRESET_ID,
    testBatchWorkflows: {
      salesOrder:
        process.env?.VUE_APP_SCM_APP_WOLT_DELIVERY_TEST_BATCH_ORDER_WORKFLOW_ID
    },
    CFLDataSetId:
      process.env.VUE_APP_SCM_APP_WOLT_DELIVERY_REPORTING_CFL_DATASET_ID,
    syncBatchWorkflowId:
      process.env.VUE_APP_SCM_APP_WOLT_DELIVERY_REPORTING_SYNC_BATCH_WORKFLOW_ID
  }
};
